export default __webpack_public_path__ + "static/media/f0020-02.5312b531.png";